<template>
  <div>
    <div class="card_form_box" v-loading="PageLoading">
      <div class="certificate">
        <div class="certificate_title">
          <p class="title_label">纺织品合格证标签制作</p>
          <div class="title_remake_box">
            <div class="tit_left">
              标准依据：参照GB5296.4《消费品使用说明 纺织品和服装使用说明》标准要求
            </div>
            <div class="tit_right">
              <el-button type="primary" size="small" class="down_btn" @click="ResetInfo">重置信息</el-button>
            </div>
          </div>
        </div>
        <el-form :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" label-width="300px" class="demo-ruleForm">
          <el-row>
            <el-col :span="rowNum">
              <el-form-item label="产品名称" prop="PRODUCT_NAME">
                <el-input v-model="ruleForm.PRODUCT_NAME"   maxlength="50" style="width: 392px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="rowNum">
              <el-form-item label="商标">
                <span slot="label">商&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;标</span>
                <el-input v-model="ruleForm.TRADE_MARK"  maxlength="50" style="width: 392px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="rowNum">
              <el-form-item label="号型规格" prop="MODEL_TYPE">
                <div class="Size_pos">
                  <div @click="ChangeSizeFocus(true,true)" class="Size_pos_layout">
                  </div>
                  <el-input v-model="ruleForm.MODEL_TYPE"  style="width: 392px;" maxlength="50" ></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="rowNum">
              <el-form-item label="款号" >
                <span slot="label">款&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</span>
                <el-input v-model="ruleForm.STYLE_NUM"  maxlength="50" style="width: 392px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="颜色" >
                <span slot="label">颜&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;色</span>
                <el-input v-model="ruleForm.COLOR"  maxlength="50" style="width: 392px;" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="成分含量">
                <span slot="label">成分含量 <span class="label_tit" > (多个成分分开添加) *</span></span>
                <div v-for="(domain, index) in ruleForm.COMPONENT" :key="index" style="display:flex;margin-bottom: 5px;align-items: center;">
                  <div>
                    <el-input v-model="domain.attrValue" style="width: 250px;"  maxlength="50" placeholder="输入纤维/填充物名称"> </el-input>
                  </div>
                  <div class="label_number">
                    <el-input-number v-model="domain.attrRate"
                                     :controls="false"
                                     style="width: 90px;margin-left: 12px;"
                                     :precision="2"
                                     :min="0.00"
                                     :max="100"
                                     maxlength="3"
                                     placeholder="填写百分比含量"
                    >
                    </el-input-number>
                    <div class="Symbol">
                      %
                    </div>
                  </div>
                  <div @click="addDomain" style="cursor: pointer;line-height: 40px;">
                    <img src="../../assets/images/add.png" >
                  </div>
                  <div @click.prevent="removeDomain(domain)" v-if="index !==0" style="margin-left: 10px;cursor: pointer;line-height: 40px;">
                    <img src="../../assets/images/minus.png" >
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="rowNum">
              <el-form-item label="产品标准编号" prop="PRODUCT_STANDARD">
                <div class="Size_pos">
                  <div @click="ChangeProductNo(true)" class="Size_pos_layout">
                  </div>
                  <el-input v-model="ruleForm.PRODUCT_STANDARD" style="width: 392px;"  maxlength="50" ></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="rowNum">
              <el-form-item label="产品质量等级" prop="PRODUCT_LEVEL">
                <el-select v-model="ruleForm.PRODUCT_LEVEL" placeholder="请选择产品质量等级" style="width: 392px;">
                  <el-option v-for="(item,index) in QualityGradeList" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="rowNum">
              <el-form-item label="安全技术要求类别" prop="SECURITY_TYPE">
                <el-select v-model="ruleForm.SECURITY_TYPE" placeholder="请选择安全技术要求类别" @change="ChangeSECURITY_TYPE" style="width: 392px;">
                  <el-option  v-for="(item,index) in RequirementCategory" :key="index" :label="item.enumName" :value="item.enumCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="rowNum">
              <el-form-item label="检验合格证明" prop="QUALIFIED_CERT">
                <el-input v-model="ruleForm.QUALIFIED_CERT"  maxlength="50" style="width: 392px;" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="rowNum">
              <el-form-item label="公司名称" prop="COMPANY_NAME">
                <el-input v-model="ruleForm.COMPANY_NAME"  maxlength="50" style="width: 392px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="rowNum">
              <el-form-item label="地址" prop="COMPANY_ADDR">
                <span slot="label">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</span>
                <el-input v-model="ruleForm.COMPANY_ADDR"  maxlength="200" style="width: 392px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="rowNum">
              <el-form-item label="产地">
                <span slot="label">产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地</span>
                <el-input v-model="ruleForm.PRODUCTING_AREA"  maxlength="50" style="width: 392px;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <SizeModelBox :SizeDialogVisible="SizeDialogVisible" :LocalKey="LocalKey"  @ChangeSizeFocus="ChangeSizeFocus" :apiHost="apiHost"></SizeModelBox>
        <ProductNo :ProductNoVisible="ProductNoVisible" @ClearProductLevel="ClearProductLevel" :SelectId="ruleForm.PRODUCT_STANDARD" @ChangeProductNo="ChangeProductNo" @FiltrationQualityGrade="FiltrationQualityGrade" :apiHost="apiHost" :ProductStandardNoList="ProductStandardNoList"></ProductNo>
      </div>
    </div>
  </div>


</template>

<script>
import SizeModelBox from "./SizeModel/SizeModelBox";
import ProductNo from './ProductStandardNo/index'
import {GetProductBatch, qryMakeToolRecord, saveMakeToolRecord,ResetCertificateInformation} from "src/request/apis";
import Cookies from 'js-cookie'
export default {
  name: "TicCertificateForm",
  components:{
    SizeModelBox,
    ProductNo
  },
  props: {
    rowNum:{
      type:Number,
      default:24
    },
    CheckFormPass:{
      type:Function,
      default:null
    },
    CloseLoading:{
      type:Function,
      default:null
    },
    GetData:{
      type:Function,
      default:null
    },
    JumpPersonalCenter:{
      type: String,
      default: ()=>''
    },
    apiHost: {
      type: String,
      default: ()=>''
    },
  },
  data() {
    return {
      PageLoading:false,
      ProductNoVisible:false,
      SizeDialogVisible:false,
      LocalKey:'SelectTypeSize',
      ruleForm: {
        PRODUCT_NAME: '',
        TRADE_MARK: '',
        MODEL_TYPE: '',
        STYLE_NUM: '',
        COLOR: '',
        PRODUCT_STANDARD: '',
        PRODUCT_LEVEL: '',
        SECURITY_TYPE: '',
        QUALIFIED_CERT: '',
        COMPANY_NAME: '',
        COMPANY_ADDR: '',
        PRODUCTING_AREA: '',
        COMPONENT: [{
          attrValue: '',
          attrRate:''
        }],
      },
      SECURITY_TYPE_VALUE:'',
      firstSizeValue:'',//第一個好型
      history:{},//历史号型
      rules: {
        PRODUCT_NAME: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
        ],
        MODEL_TYPE: [
          { required: true, message: '请输入号型规格', trigger: 'blur' },
        ],
        PRODUCT_STANDARD: [
          { required: true, message: '请输入产品标准编号', trigger: 'blur' },
        ],
        PRODUCT_LEVEL: [
          { required: true, message: '请选择产品质量等级', trigger: 'change' }
        ],
        SECURITY_TYPE: [
          { required: true, message: '请选择安全技术要求类别', trigger: 'change' }
        ],
        QUALIFIED_CERT: [
          { required: true, message: '请输入检验合格证明', trigger: 'blur' },
        ],
        COMPANY_NAME: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
        ],
        COMPANY_ADDR: [
          { required: true, message: '请输入地址', trigger: 'blur' },
        ]
      },
      ProductStandardNoList:[],
      QualityGradeList:[],
      RequirementCategory:[],
      GetProductListValue:[
        {
          tableName:'TOOLKIT',
          colName:'TEC_REQ'
        },
        {
          tableName:'TOOLKIT',
          colName:'SL_STAND'
        }
      ],
      FormData:[]
    };
  },
  computed:{
    SECURITY_TYPE_VALUE_VAL(){
        return {
          list:this.RequirementCategory,
          value:this.ruleForm.SECURITY_TYPE
        }
    }
  },
  watch:{
    ruleForm:{
      handler(newVal,oldVal){
        this.FormFormat(newVal)
      },
      deep:true
    },
    SECURITY_TYPE_VALUE_VAL:{
      handler(newVal){
        if(newVal.list.length&&newVal.value){
          this.ChangeSECURITY_TYPE(newVal.value)
        }
      },
      deep:true
    },
    SECURITY_TYPE_VALUE:{
      handler(newVal,oldVal){
        if(newVal){
          this.FormData.forEach((item,index)=>{
            if(item.label==='安全技术要求类别'){
              this.$set(this.FormData[index],'value',newVal)
              this.GetData(this.FormData)
            }
          })
        }
      },
      deep:true,
      immediate:true
    },
  },
  mounted() {
    let list=JSON.parse(localStorage.getItem('label1'))
    if(list){
      this.AssembleFormData(list.normalList)
    }else{
      this.GetFormList()
    }

  },
  created() {
    this.GetProductList(this.GetProductListValue)
  },
  methods: {
    //重置信息
    ResetInfo(){
      ResetCertificateInformation({
        toolCode:'SL_TOOLKIT001',
        makeType:"100"
      },this.apiHost).then(res=>{
         if(res.resultCode==='0'){
           localStorage.removeItem('label1')
           localStorage.removeItem('SelectTypeSize')
           this.SECURITY_TYPE_VALUE=''
           this.ruleForm={
              PRODUCT_NAME: '',
              TRADE_MARK: '',
              MODEL_TYPE: '',
              STYLE_NUM: '',
              COLOR: '',
              PRODUCT_STANDARD: '',
              PRODUCT_LEVEL: '',
              SECURITY_TYPE: '',
              QUALIFIED_CERT: '',
              COMPANY_NAME: '',
              COMPANY_ADDR: '',
              PRODUCTING_AREA: '',
              COMPONENT: [{
                attrValue: '',
                attrRate:''
               }],
           }
           this.$refs['ruleForm'].resetFields();
           this.GetFormList()
         }
      }).catch(err=>{

      })
    },
    //处理左侧form数据传递到card
    FormFormat(newVal){
      this.FormData=[
        {
          label:'产品名称',
          value:newVal.PRODUCT_NAME,
          required: true,
        },
        {
          label:'商标',
          value:newVal.TRADE_MARK,
          required: false,
        },
        {
          label:'号型',
          value:newVal.MODEL_TYPE,
          required: true,
          firstValue:newVal.firstSizeValue
        },
        {
          label:'款号',
          value:newVal.STYLE_NUM,
          required: false,
        },
        {
          label:'颜色',
          value:newVal.COLOR,
          required: false,
        },
        {
          label:'成分含量',
          value:this.ComponentContent(newVal.COMPONENT),
          required: true,
        },
        {
          label:'产品标准编号',
          value:newVal.PRODUCT_STANDARD,
          required: true,
        },
        {
          label:'产品质量等级',
          value:newVal.PRODUCT_LEVEL,
          required: true,
        },
        {
          label:'安全技术要求类别',
          value:this.SECURITY_TYPE_VALUE || '',
          required: true,
        },
        {
          label:'检验合格证明',
          value:newVal.QUALIFIED_CERT,
          required: true,
        },
        {
          label:'公司名称',
          value:newVal.COMPANY_NAME,
          required: true,
        },
        {
          label:'地址',
          value:newVal.COMPANY_ADDR,
          required: true,
        },
        {
          label:'产地',
          value:newVal.PRODUCTING_AREA,
          required: false,
        }
      ]
      this.GetData(this.FormData)
      let form=this.CertificateFormData()
      let accessToken = Cookies.get('SSO_TOKEN')
      if(form&&accessToken) localStorage.setItem('label1',JSON.stringify(form))
    },
    ChangeSECURITY_TYPE(val){
      let arr=this.RequirementCategory.filter(s=>{
        return s.enumCode===val
      })
      if(arr.length>0){
        this.SECURITY_TYPE_VALUE=arr[0].enumName
      }
    },
    GetFormList(){
      this.PageLoading=true
      qryMakeToolRecord({
        toolCode:'SL_TOOLKIT001',
        makeType:"100"
      },this.apiHost).then(res=>{
        if(res&&res.data){
          if(res.data.normalList){
            this.AssembleFormData(res.data.normalList)
          }
        }
        this.PageLoading=false

      }).catch(err=>{
        if(err.resultCode==='6001'){
          this.$router.push({
            path:this.JumpPersonalCenter
          })
        }
        this.PageLoading=false
      })
    },
    //处理缓存form数据  或者后端返回数据
    AssembleFormData(normalList){
      let tempFrom = {
        PRODUCT_NAME: '',
        TRADE_MARK: '',
        MODEL_TYPE: '',
        STYLE_NUM: '',
        COLOR: '',
        PRODUCT_STANDARD: '',
        PRODUCT_LEVEL: '',
        SECURITY_TYPE: '',
        QUALIFIED_CERT: '',
        COMPANY_NAME: '',
        COMPANY_ADDR: '',
        PRODUCTING_AREA: '',
        COMPONENT: [{
          attrValue: '',
          attrRate:''
        }],
      }
      Object.keys(tempFrom).forEach((key) => {
        if(key !=='MODEL_TYPE'){
          let arrfind=normalList.find(item=>{
            return item.attrCode===key
          })
          if(key==='COMPONENT'){
            if(arrfind.items.length>0){
              tempFrom[key]=arrfind.items
            }else{
              tempFrom[key]=[{
                attrValue: '',
                attrRate:''
              }]
            }
          }else{
            tempFrom[key]=arrfind.attrValue
          }
        }
      })
      this.ruleForm = JSON.parse(JSON.stringify((tempFrom)))
      this.SizeTotal()
    },
    //选择产品编号筛选质量等级
    FiltrationQualityGrade(data){
        this.QualityGradeList=[]
        this.ruleForm.PRODUCT_STANDARD=data.enumCode
        let string2 = data.remark
        let string2Result = string2.split(',')
        string2Result.forEach(item=>{
          this.QualityGradeList.push({
            label:item,
            value:item
          })
        })
    },
    //安全技术要求类别
    GetProductList(data){
      GetProductBatch(data,this.apiHost).then((res) => {
        if(res.data['TOOLKIT.TEC_REQ']){
          this.RequirementCategory=res.data['TOOLKIT.TEC_REQ']
          this.ChangeSECURITY_TYPE(this.ruleForm.SECURITY_TYPE)
        }
        if(res.data['TOOLKIT.SL_STAND']){
          this.ProductStandardNoList=res.data['TOOLKIT.SL_STAND']
        }
      }).catch((e) => {
        this.loading = false
      })
    },
    //成分含量解构
    ComponentContent(list){
      let arr=[]
      list.forEach(item=>{
        if(item.attrValue){
          arr.push(`<div>${item.attrValue}:  ${item.attrRate}%</div>`)
        }
      })
      return arr.join('')
    },
    //统计号型总数
    SizeTotal(){
      let SelectTypeSize=JSON.parse(localStorage.getItem(this.LocalKey))
      let num=0
      let str=''
      let num1=''
      let num0=''
      if(SelectTypeSize&&SelectTypeSize.Size.length){
        SelectTypeSize.Size.map(item=>{
          if(item.name !=='OtherProducts'){
            num+=item.list.length
          }else{
            str=item.list
          }
        })
        let arr=SelectTypeSize.Size.find(item=>{
          if(item.name !=='OtherProducts'){
            return item.list.length>0
          }
        })
        if(arr){
          num0=arr.list[0].typeValue
        }
        if(num>1){
          num1=`共计${num}种号型`
        }else{
          if(arr){
            num1=num0
          }else{
            num1=''
          }
        }
        if(num0){
          this.$set(this.ruleForm,'firstSizeValue',num0)
        }else {
          this.$set(this.ruleForm,'firstSizeValue',` ${str?`其他产品:${str}`:''}`)
        }
        if(num1){
          this.$set(this.ruleForm,'MODEL_TYPE',num1+` ${str?`(其他产品:${str})`:''}`)
        }else{
          this.$set(this.ruleForm,'MODEL_TYPE',` ${str?`其他产品:${str}`:''}`)
        }
      }
    },
    //获取号型
    ChangeSizeFocus(val,type){
      if(!type&&this.history){
        localStorage.setItem(this.LocalKey, JSON.stringify(this.history))
      }else{
        this.history=JSON.parse(localStorage.getItem(this.LocalKey))
      }
      this.SizeDialogVisible=val
    },
    //选择产品编号
    ChangeProductNo(val){
      this.ProductNoVisible=val
    },
    //确定清空质量等级
    ClearProductLevel(){
      this.ruleForm.PRODUCT_LEVEL=''
    },
    ChangeValue(index){
      let data=this.ruleForm.COMPONENT
      this.$nextTick(() => {
        // data[index].attrRate=parseInt(data[index].attrRate)
        data=parseFloat(data)
        data[index].attrRate=parseFloat(data.toFixed(2))
      })
    },
    //验证成分含量
    CheckComponentContent(){
      let data=this.ruleForm.COMPONENT
      let isEmpty=true //是否所有输入框填写
      let isContent=true //含量100
      let arr=[]
      data.forEach(item=>{
        arr.push(item.attrValue)
      })
      isEmpty = !arr.some(val => val === '');
      if(isEmpty){
        let sum=0
        for(let i in data){
          sum+=Number(data[i].attrRate)
        }
        if(sum !==100){
          isContent=false
        }
      }
      if(!isEmpty){
        this.CloseLoading()
        return this.$message({
          message: '请填写成分含量',
          type: 'warning'
        });
      }
      if(!isContent){
        this.CloseLoading()
        return this.$message({
          message: '成分含量的合计应为100%，请重新输入',
          type: 'warning'
        });
      }
      if(isEmpty&&isContent){
        this.FormatFormData()
      }
    },
    CertificateFormData(){
      let localData=JSON.parse(localStorage.getItem(this.LocalKey))
      let list=[]
      let SelectTypeSize
      this.ruleForm.COMPONENT.forEach(item=>{
        list.push({
          attrRate: item.attrRate,
          attrValue: item.attrValue
        })
      })
      if(localData) {
        localData.Ingredients = list
        localStorage.setItem(this.LocalKey, JSON.stringify(localData))
        SelectTypeSize = localData.Size

      }
      let sizeList=[]
      if(SelectTypeSize){
        SelectTypeSize.map(item=>{
          if(item.name==='OtherProducts'){
            sizeList.push({
              attrValue:item.list
            })
          }else{
            item.list.map(val=>{
              sizeList.push({
                attrValue:val.typeValue
              })
            })
          }
        })
      }
        let {
          PRODUCT_NAME,
          TRADE_MARK,
          STYLE_NUM,
          COLOR,
          PRODUCT_STANDARD,
          PRODUCT_LEVEL,
          SECURITY_TYPE,
          QUALIFIED_CERT,
          COMPANY_NAME,
          COMPANY_ADDR,
          PRODUCTING_AREA,
          COMPONENT,
        }=this.ruleForm
        return {
          toolCode: "SL_TOOLKIT001",
          makeType: "100",
          state: 1,
          normalList: [
            {
              attrName: "产品名称",
              attrCode: "PRODUCT_NAME",
              attrValue: PRODUCT_NAME
            },
            {
              attrName: "商标",
              attrCode: "TRADE_MARK",
              attrValue: TRADE_MARK
            },

            {
              attrName: "成分含量",
              attrCode: "COMPONENT",
              items: COMPONENT
            },
            {
              attrName: "号型规格",
              attrCode: "MODEL_TYPE",
              items: sizeList
            },
            {
              attrName: "款号",
              attrCode: "STYLE_NUM",
              attrValue: STYLE_NUM
            },
            {
              attrName: "颜色",
              attrCode: "COLOR",
              attrValue: COLOR
            },
            {
              attrName: "产品标准编号",
              attrCode: "PRODUCT_STANDARD",
              attrValue: PRODUCT_STANDARD
            },
            {
              attrName: "产品质量等级",
              attrCode: "PRODUCT_LEVEL",
              attrValue: PRODUCT_LEVEL
            },
            {
              attrName: "安全技术要求类别",
              attrCode: "SECURITY_TYPE",
              attrValue: SECURITY_TYPE
            },
            {
              attrName: "检验合格证明",
              attrCode: "QUALIFIED_CERT",
              attrValue: QUALIFIED_CERT
            },
            {
              attrName: "公司名称",
              attrCode: "COMPANY_NAME",
              attrValue: COMPANY_NAME
            },
            {
              attrName: "地址",
              attrCode: "COMPANY_ADDR",
              attrValue: COMPANY_ADDR
            },
            {
              attrName: "产地",
              attrCode: "PRODUCTING_AREA",
              attrValue: PRODUCTING_AREA
            }
          ]
        }



    },
    //处理保存数据
    FormatFormData(){
      this.$refs.ruleForm.validate()
      let FormData=this.CertificateFormData()
      let arr=FormData.normalList.find(val=>{
        return val.attrCode==='MODEL_TYPE'
      })
      if(arr.items.length){
        saveMakeToolRecord(FormData,this.apiHost).then((res) => {
          if(res&&res.resultCode==='0'){
            this.$message.success('保存成功，下载中......');
            this.CheckFormPass()
          }else{
            this.$message.error(res.resultMsg);
          }
        }).catch((e) => {
        })
      }else{
        this.ruleForm.MODEL_TYPE=''
        this.$refs.ruleForm.validateField('MODEL_TYPE')
      }

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.CheckComponentContent()
        } else {
          this.CloseLoading()
          this.$message('请填写必填项后再下载');
          console.log('error submit!!');
          return false;
        }
      });
    },
    removeDomain(item) {
      let index = this.ruleForm.COMPONENT.indexOf(item)
      if (index !== -1) {
        this.ruleForm.COMPONENT.splice(index, 1)
      }
    },
    addDomain() {
      this.ruleForm.COMPONENT.push({
        attrValue: '',
        attrRate:'',
      });
    }
  }

}
</script>

<style lang="scss" scoped>
.card_form_box{
  display: flex;
  background: #FFFFFF;
  padding-left: 31px;
  padding-top: 20px;
  .certificate{
    flex: 1;
    .certificate_title{
      .title_label {
        font-size: 30px;
        font-weight: 400;
        color: #333333;
        text-align: center;
        margin-bottom: 20px;
      }

      .title_remake {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        margin-bottom: 20px;
      }
      .title_remake_box{
        display: flex;
        width: 80%;
        .tit_left{
          flex: 1;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          margin-bottom: 20px;
        }
        .tit_right{
          width: 200px;
          .down_btn{
            display: inline-block;
            width: 100px;
            height: 32px;
            background: #CA4300;
            border-radius: 3px;
            border: 1px solid #CA4300;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
            cursor: pointer;
            text-align: center;
          }
        }
      }
    }

    .label_tit{
      font-size: 14px;
      color: #FF0000;
      font-weight: 500;
    }
    .label_number{
      display: flex;
      margin-right: 10px;
      .Symbol{
        width: 40px;
        height: 40px;
        border: 1px solid #cccccc;
        background: #f5f7fa;
        text-align: center;
        border-left: none;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        color: #747474;
      }
    }
  }

}

.Size_pos{
  position: relative;
  height: 40px;
  .Size_pos_layout{
    position: absolute;
    width: 392px;
    height: 40px;
    z-index: 1;
  }
  .el-input{
    position: absolute;
    z-index: 0;
  }
}
::v-deep .label_number .el-input__inner{
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
::v-deep .el-form-item__label{
  color: #333333;
  font-weight: bold;
  padding: 10px 0 20px 0;
  line-height: 0;
}
::v-deep .el-form-item{
  margin-bottom: 16px;
}
</style>